module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-120.e47e2f30.svg";